export default {
    title: "Kostenstellen",
    identifier: "Kostenstelle",
    name: "Bezeichnung",
    status: "Status",
    active: "Aktiv",
    inactive: "Inaktiv",
}